import { OptionsMenuStorybook } from "@finanedi.es/storybook"
import {
  faArrowDownToBracket,
  faFileContract,
  faFileInvoice,
  faFileLines,
} from "@fortawesome/pro-light-svg-icons"
import { PresupuestoReadingFiltersDtoProps } from "api/DTOs/PresupuestoReadingFiltersDto"
import { formatCurrency } from "common/utils/currency"
import { TYPES_DOCUMENTOS } from "features/Crear/pages/FormCreacionDocumento/constant"
import { EstadoRevisionActual } from "features/Documentos/components/EstadoRevisionActual/EstadoRevisionActual"
import { TFunction } from "i18next"
import { frontendDateFormat } from "utils/formatDate"

interface ColumnasPresupuestosParams {
  t: TFunction
  handleDownloadPdfPresupuesto: (
    id: string,
    serie: string,
    t: TFunction
  ) => Promise<void>
  handleConvertirDocumento: (
    rowData: PresupuestoReadingFiltersDtoProps,
    finalType: string
  ) => void
  showContacto?: boolean
}
export const PRESUPUESTOS_ENVIADOS_COLUMNS_ERP = ({
  t,
  handleDownloadPdfPresupuesto,
  handleConvertirDocumento,
  showContacto = true,
}: ColumnasPresupuestosParams) => {
  const columns = [
    {
      header: t("crear.presupuesto.tab.headerEmiDate"),
      field: "fechaEmision",
      key: "fechaEmision",
      body: ({ fechaEmision }: PresupuestoReadingFiltersDtoProps) =>
        fechaEmision ? frontendDateFormat(new Date(fechaEmision)) : "",
      style: { width: "10%" },
      sortable: true,
      className: "!tw-text-start",
      bodyClassName: "!tw-text-start",
      sortField: "fechaEmision",
    },
    {
      header: t("crear.presupuesto.tab.headerNumQuote"),
      field: "serie",
      key: "serie",
      style: { width: "15%" },
      sortable: true,
      sortField: "serie",
    },
    showContacto
      ? {
          header: t("crear.factura.tab.headerCliente"),
          key: "cliente",
          field: "Librado.RazonSocial",
          body: (rowData: PresupuestoReadingFiltersDtoProps) => {
            return `${rowData.razonSocialLibrado} (${rowData.nifLibrado})`
          },
          sortable: true,
          sortField: "Librado.RazonSocial",
        }
      : {},
    {
      header: t("crear.presupuesto.tab.headerState"),
      field: "estadoRevisionActual",
      key: "estadoRevisionActual",
      body: ({ estadoRevisionActual }: PresupuestoReadingFiltersDtoProps) => {
        return estadoRevisionActual
          ? EstadoRevisionActual(estadoRevisionActual)
          : ""
      },
      style: { width: "11%" },
      sortable: true,
      alignCol: "center",
      sortField: "estadoRevisionActual",
    },
    {
      header: t("crear.presupuesto.tab.headerImport"),
      field: "importe",
      key: "importe",
      className: "!tw-text-end",
      style: { width: "11%" },
      body: ({ importe }: PresupuestoReadingFiltersDtoProps) =>
        formatCurrency(importe),
      sortable: true,
      alignCol: "right",
      sortField: "importe",
    },
    {
      key: "opciones",
      style: { width: "4%" },
      className: "!tw-p-2",
      bodyClassName: "!tw-w-auto tw-flex tw-justify-end",
      body: (rowData: PresupuestoReadingFiltersDtoProps) => {
        if (!rowData.id) return null
        return (
          <OptionsMenuStorybook
            id={rowData.id}
            items={[
              {
                title: `${t("crear.factura.tab.downloadLabel")}`,
                hasRedirect: true,
                action: () => {
                  rowData.id &&
                    handleDownloadPdfPresupuesto(
                      rowData.id,
                      `${rowData.serie}`,
                      t
                    )
                },
                icon: faArrowDownToBracket,
              },
              {
                title: `${t("crear.presupuesto.tab.convertirLabel")}`,
                hasRedirect: false,
                subMenu: [
                  {
                    title: `${t("asociateDoc.orderLabel")}`,
                    action: () =>
                      handleConvertirDocumento(
                        rowData,
                        TYPES_DOCUMENTOS.PEDIDO
                      ),
                    icon: faFileLines,
                  },
                  {
                    title: `${t("asociateDoc.deliveryLabel")}`,
                    action: () =>
                      handleConvertirDocumento(
                        rowData,
                        TYPES_DOCUMENTOS.ALBARAN
                      ),
                    icon: faFileContract,
                  },
                  {
                    title: `${t("asociateDoc.invoiceLabel")}`,
                    action: () =>
                      handleConvertirDocumento(
                        rowData,
                        TYPES_DOCUMENTOS.FACTURA
                      ),
                    icon: faFileInvoice,
                  },
                ],
              },
            ]}
            position='right'
          />
        )
      },
    },
  ]
  return columns
}
